import {createSlice} from '@reduxjs/toolkit';

interface TransactionInitialState {
  tableFilterId: string;
  tableLoading: boolean;
  transactionModal: boolean;
}

const initialState: TransactionInitialState = {
  tableFilterId: '',
  tableLoading: false,
  transactionModal: false,
};

const transactionSlice = createSlice({
  name: 'transaction',
  initialState: initialState,
  reducers: {
    setTransactionTableFilterId: (state, action) => {
      state.tableFilterId = action.payload;
    },
    setTransactionTableLoading: (state, action) => {
      state.tableLoading = action.payload;
    },
    openTransactionModal: (state) => {
      state.transactionModal = !state.transactionModal;
    },
  },
});

export const {
  setTransactionTableFilterId,
  setTransactionTableLoading,
  openTransactionModal,
} = transactionSlice.actions;
export default transactionSlice.reducer;
